import type { FC } from "react";

const ChoiceElement: FC<{ handleClick: () => void; title: string }> = ({
  handleClick,
  title,
}) => (
  <button
    type="button"
    onMouseDown={(e) => e.preventDefault()}
    onClick={handleClick}
    className="form-choice-item w-full rounded-lg px-3 py-2.5 text-left font-onest text-[15px] text-slate-700 transition-colors hover:bg-brand-50 hover:text-brand-700 focus-visible:bg-brand-50 focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-brand-500/20"
  >
    {title}
  </button>
);

export default ChoiceElement;
